/**
 * @generated SignedSource<<de3191e4b631b7ae64e919d69c48e9fa>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "claimRequest"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "request",
        "variableName": "claimRequest"
      }
    ],
    "concreteType": "Impulse",
    "kind": "LinkedField",
    "name": "impulseByClaim",
    "plural": false,
    "selections": [
      (v1/*: any*/),
      {
        "alias": null,
        "args": null,
        "concreteType": "ImpulseService",
        "kind": "LinkedField",
        "name": "impulseService",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Service",
            "kind": "LinkedField",
            "name": "service",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "version",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "status",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "claim",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "homeOpenImplComponentsImpulseByClaimQuery",
    "selections": (v2/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "homeOpenImplComponentsImpulseByClaimQuery",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "a2d548a2dd6f4a76eb99a06ca92b5a6f",
    "id": null,
    "metadata": {},
    "name": "homeOpenImplComponentsImpulseByClaimQuery",
    "operationKind": "query",
    "text": "query homeOpenImplComponentsImpulseByClaimQuery(\n  $claimRequest: ClaimRequestInput\n) {\n  impulseByClaim(request: $claimRequest) {\n    id\n    impulseService {\n      service {\n        id\n        version\n      }\n    }\n    status\n    claim\n  }\n}\n"
  }
};
})();

node.hash = "0b1f11707e90027fdd1d83f2c3b1f297";

module.exports = node;
